export enum Currency {
  SEK = "SEK",
  NOK = "NOK"
}
